export default __webpack_public_path__ + "static/media/47-Astana.2c6d2692.jpg";